import { FormattedMessage } from "react-intl";

import { DEFAULT_VALUES, useLocalizedHref } from "@/libraries/web-framework";

const UserRolesPermissionsSpork = () => (
    <div>
        <h2>
            <FormattedMessage
                id="JiraSoftwarePricingPage.modalContents.user-roles-permissions-spork.title"
                defaultMessage="User roles and permissions"
            />
        </h2>
        <p>
            <FormattedMessage
                id="JiraSoftwarePricingPage.modalContents.user-roles-permissions-spork.bodyOne"
                defaultMessage="Assign roles to different users, like administrator or end-user. In the Free plan, every user is a project admin. Different permissions apply to users depending on their role."
            />
        </p>
        <p>
            <FormattedMessage
                id="JiraSoftwarePricingPage.modalContents.user-roles-permissions-spork.bodyTwo"
                defaultMessage="Set permissions to control which users can create new projects and what users can do, see, and comment on within a project or issue. Permission settings for projects or issues are only available on paid plans."
            />
        </p>
        <p>
            <FormattedMessage
                id="JiraSoftwarePricingPage.modalContents.user-roles-permissions-spork.learnMore"
                defaultMessage="<learnMore>Learn more</learnMore> about users and permissions."
                values={{
                    ...DEFAULT_VALUES,
                    learnMore: (chunks) => (
                        <a
                            data-event="clicked"
                            data-event-component="linkButton"
                            data-product-key="jiraSoftware"
                            // eslint-disable-next-line react-hooks/rules-of-hooks
                            href={useLocalizedHref(
                                "/software/jira/guides/permissions/overview#what-are-permissions-and-permission-schemes"
                            )}
                        >
                            {chunks}
                        </a>
                    )
                }}
            />
        </p>
    </div>
);

export default UserRolesPermissionsSpork;
